<template>


  <p class="text-4xl text-secondary font-extrabold text-center lg:pt-16 ">Sınırları Kaldıran Kolay Yatırım</p>
  <p class="max-w-5xl mx-auto text-2xl text-primary text-center py-6">
    Dünya genelinde gayrimenkul yatırımı yapmak artık online alışveriş kadar kolay. Karmaşık evrak işleriyle uğraşmaya
    gerek kalmadan, blokzincir teknolojisi ile hızlı ve güvenli yatırım yapın.
  </p>

  <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12">
    <div v-for="(item, index) in assets" :key="index"
      class="relative bg-white border border-gray-200 rounded-lg shadow-sm">
      <div class="absolute flex items-center justify-center p-4 bg-secondary text-white rounded-t-lg">
        YAKINDA
      </div>
        <img class="rounded-t-lg opacity-15" :src="item.img" alt="" />
      
      <div class="p-5">
        <div class="flex flex-row justify-between">

          <h5 class="mb-2 text-2xl font-bold tracking-tight text-primary">
            {{ item.name }}
          </h5>
          <h5 class="mb-2 text-lg font-bold tracking-tight text-secondary">
          {{ item.total_supply }} Bloqs
          </h5>
     
      </div>
        <p class="mb-3 font-normal text-gray-700">
          {{ item.description }}
        </p>
        <div class="flex flex-col justify-between pb-6">
          <span class="text-sm font-medium text-gray-900">
            Konum: {{ item.location }}
          </span>
          <span class="text-sm font-medium text-gray-900">
            Mülk Tipi: {{ item.type }}
          </span>
        </div>
        <div class="flex flex-row justify-between">
          <span class="text-xs font-medium text-gray-900">
            İlk Değerleme: {{ formatPrice(Number(item.initial_valuation), item.country) }}
          </span>
          <span class="text-xs font-medium text-gray-900">
            Son Değerleme: {{ formatPrice(Number(item.current_valuation), item.country) }}
          </span>
        </div>

        <div class="flex flex-row justify-between">
          <span class="text-xs font-medium text-gray-900">
            İlk fiyat: {{ formatPrice(Number((item.initial_valuation / item.total_supply).toFixed(2)), item.country) }} / Bloq
          </span>
          <span class="text-xs font-medium text-gray-900">
            Son Fiyat: {{ formatPrice(Number((item.current_valuation / item.total_supply).toFixed(2)), item.country) }} / Bloq
          </span>
        </div>


        <div class="flex flex-row justify-between items-center mt-4">
          <h2 class="font-bold text-center pt-4">{{ formatPrice(Number((item.current_valuation / item.total_supply)), item.country)  }} / Bloq</h2>
        <a href="#waitlist"
          class="inline-flex items-center px-3 py-2 mt-4 text-sm font-medium text-center text-white bg-secondary rounded-lg hover:bg-primary">
          Yatırım yap
          <svg class="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 14 10">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M1 5h12m0 0L9 1m4 4L9 9" />
          </svg>
        </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted  } from 'vue';
import axios from 'axios';
import type { Asset } from '@/types/asset'; // Eğer ayrı dosyadaysa

export default defineComponent({
  name: 'AssetItem',
  setup() {
    const assets = ref<Asset[]>([]);
    const loading = ref(true);
    // Dummy data
   
    const fetchAssets = async () => {
      try {
        const response = await axios.get(
          'https://qktroklpzaaadyjatqak.supabase.co/rest/v1/assets?select=*',
          {
            headers: {
              apikey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFrdHJva2xwemFhYWR5amF0cWFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyODg1NjAsImV4cCI6MjA1ODg2NDU2MH0.Qm7pQjE9OyIQrVJNyZKwJFaXLfNHocHln7ml1R2KwSI',
              Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFrdHJva2xwemFhYWR5amF0cWFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyODg1NjAsImV4cCI6MjA1ODg2NDU2MH0.Qm7pQjE9OyIQrVJNyZKwJFaXLfNHocHln7ml1R2KwSI'
            }
          }
        );
        assets.value = response.data;
      } catch (err) {
        //error.value = err;
        console.error('Error fetching assets:', err);
      } finally {
        loading.value = false;
      }
    };


    const formatPrice = (price: number, country: string | undefined) => {
      const numPrice = Number(price);
      if (isNaN(numPrice)) return 'N/A';

      // Ensure price is treated as a number with 2 decimal places for formatting
      const fixedPrice = parseFloat(numPrice.toFixed(2));

      switch (country?.toUpperCase()) {
        case 'TR':
          return `${fixedPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`;
        case 'UK':
          // style: 'currency' with 'en-GB' locale correctly places '£'
          return `${fixedPrice.toLocaleString('en-GB', { style: 'currency', currency: 'GBP', minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        default:
          // Default formatting if country is not TR or UK, or is undefined
          return `${fixedPrice.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
      }
    };
    onMounted(fetchAssets);
    return { assets ,formatPrice };
  }
});
</script>

<style scoped>
h1 {
  font-size: 24px;
  margin-bottom: 20px;
}
</style>